import React, { useState, useEffect, useContext, useRef } from "react";
import { LangContext } from "../../context/langContext";
import { UserContext } from "../../context/userContext";
import { MyAccountContainer, ProfileImage } from "./MyAccountStyled";

import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import back from './../../utils/images/arrow_back.svg';
import avatar from './../../utils/images/avatar_fluincr.png';
import share from './../../utils/images/share_new.svg';
import edit from './../../utils/images/edit.svg';

//import { /* securityQuestionOptions, */ addressOptions } from "../../utils/constants/general";

import Select, { components } from 'react-select';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import { utils } from '@hassanmojab/react-modern-calendar-datepicker';
import { getCountries } from "../../api/filtersApi";

import { identificationTypes, identificationTypesCompany } from "../../utils/constants/general";
import { getCheckEmailAvailability, getCompanyEmailToVerified, getCompanyNameToVerified, getDeleteAccount, getInfluencerEmailToVerified, getInfluencerNameToVerified, getSecurityQuestions, postEditUserDataInfluencer, putEditUserDataCompany } from "../../api/myAccountApi";


import Spinner from './../../components/Spinner/Spinner';
import Alert from './../../components/Alert/Alert';
import ModalSecurityCode from "../../components/ModalSecurityCode/ModalSecurityCode";
import ModalChangePassword from "../../components/ModalChangePassword/ModalChangePassword";
import { toUpperCase } from "../../services/generalSevices";
import { deleteInfluencerAccount } from "../../api/influencerApi";
import { deleteCompanyAccount } from "../../api/companyApi";
import SocialMedia from "../../components/SocialMedia/SocialMedia";
import { URLplatform, paypalURL } from "../../utils/constants/constants";
import { paypalConect, paypalDisconect } from "../../api/paypalApi";


export default function MyAccount() {

    const navigate = useNavigate();
    const intl = useIntl();
    const { locale } = useContext(LangContext);

    const birthdayRef = useRef(null);
    const shareRef = useRef(null);
    const { Option } = components;

    const [isLoading, setIsLoading] = useState(false);
    const [showAlertChangeSuccessful, setShowAlertChangeSuccessful] = useState(false);
    const [showAlertChangeFail, setShowAlertChangeFail] = useState(false);
    const [showAlertDeleteAccount, setShowAlertDeleteAccount] = useState(false);
    const [showDeletePayment, setShowDeletePayment] = useState(false);

    const { userToken, setUserToken, userType, setUserType, name, setName, lastName, setLastName, companyName, setCompanyName, imageProfile, setImageProfile, account, setAccount, active, setActive, verified, setVerified, statusAccount, setStatusAccount, uniqueName, setUniqueName, auxUniqueName, setAuxUniqueName, email, setEmail, auxEmail, setAuxEmail, secondEmail, setSecondEmail, password, setPassword, twoStepVerification, setTwoStepVerification, securityQuestion, setSecurityQuestion, securityQuestionAnswer, setSecurityQuestionAnswer, indicativePhone, setIndicativePhone, phone, setPhone, typeIdentification, setTypeIdentification, identification, setIdentification, gender, setGender, birthday, setBirthday, address, setAddress, zipCode, setZipCode, payment, setPayment, promotions, setPromotions, colaborations, setColaborations, city, setCity, country, setCountry } = useContext(UserContext);


    const [selectedDay, setSelectedDay] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState('paypal');

    const [editInfluencerName, setEditInfluencerName] = useState(false);
    const [editUserName, setEditUserName] = useState(false);
    const [editEmail, setEditEmail] = useState(false);
    const [editSecondaryEmail, setEditSecondaryEmail] = useState(false);
    const [editPassword, setEditPassword] = useState(false);
    const [editSecurityQuestion, setEditSecurityQuestion] = useState(false);
    const [editPhone, setEditPhone] = useState(false);
    const [editIdentification, setEditIdentification] = useState(false);
    const [editGender, setEditGender] = useState(false);
    const [editBirthday, setEditBirthday] = useState(false);
    const [editAddress, setEditAddress] = useState(false);
    const [editPaymentMethod, setEditPaymentMethod] = useState(false);

    const [countriesOptions, setCountriesOptions] = useState([]);
    const [indicativesOptions, setIndicativesOptions] = useState([]);
    const [securityQuestionOptions, setSecurityQuestionOptions] = useState([]);
    const [addressDetails, setAddressDetails] = useState('');
    const [selectCountry, setSelectCountry] = useState('');
    const [selectIndicative, setSelectIndicative] = useState('');
    //const [city, setCity] = useState('');

    const [body, setBody] = useState({});
    const [isUniqueNameAvailable, setIsUniqueNameAvailable] = useState(true);
    const [isUniqueNameEmpty, setIsUniqueNameEmpty] = useState(false);
    const [isEmailAvailable, setIsEmailAvailable] = useState(true);
    const [showSecurityCode, setShowSecurityCode] = useState(false);
    const [isEmailVerified, setIsEmailVerified] = useState(false);


    const [isEmailValid, setIsEmailValid] = useState(true);
    const [isPasswordValid, setIsPasswordValid] = useState(true);
    const [isPhoneValid, setIsPhoneValid] = useState(true);

    const [showCustomPronoun, setShowCustomPronoun] = useState(false);

    const [showEdit, setShowEdit] = useState(false);

    const [showEditPassword, setShowEditPassword] = useState(false);

    const [showAlertConfirmDelete, setShowAlertConfirmDelete] = useState(false);
    const [showSocialMedia, setShowSocialMedia] = useState(false);


    const [phoneIndex, setPhoneIndex] = useState(0);
    const [questionIndex, setQuestionIndex] = useState(0);
    const [identificationIndex, setIdentificationIndex] = useState(0);
    const [countryIndex, setCountryIndex] = useState(0);

    const [showAlertUserExists, setShowAlertUserExists] = useState(false);

    const url = `${URLplatform}/${uniqueName}`;

    useEffect(() => {
        function handleClickOutside(event) {
            if (birthdayRef.current && !birthdayRef.current.contains(event.target)) {
                setEditBirthday(false);
            }
            if (shareRef.current && !shareRef.current.contains(event.target)) {
                setShowSocialMedia(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [birthdayRef, shareRef])

    useEffect(() => {
        if (selectedDay !== null) {
            //const date = `${selectedDay.year}-${selectedDay.month}-${selectedDay.day}`;
            const date = `${selectedDay.year}-${(selectedDay.month < 10) ? '0' + selectedDay.month : selectedDay.month}-${(selectedDay.day < 10) ? '0' + selectedDay.day : selectedDay.day}`;
            setBirthday(date);
            const auxBody = { ...body }
            auxBody.birthday_ = date;
            setBody(auxBody)
        }
    }, [selectedDay])

    useEffect(() => {
        getCountries().then((response) => {
            const auxCountries = [];
            const auxIndicatives = [];
            response.map((country) => {
                if (locale === 'es-CO') {
                    auxCountries.push({ value: country.id, label: country.nombre, nombre: country.nombre, name: country.name, flag: country.image })
                } else {
                    auxCountries.push({ value: country.id, label: country.name, nombre: country.nombre, name: country.name, flag: country.image })
                }

                auxIndicatives.push({ value: country.indicative, label: country.indicative, flag: country.image })
            })
            setCountriesOptions(auxCountries);
            setSelectIndicative(auxIndicatives[0].label);

            setIndicativesOptions(auxIndicatives);
        })

        getSecurityQuestions().then((response) => {
            const auxQuestions = [];
            response.map((question) => {
                if (locale === 'es-CO') {
                    auxQuestions.push({ value: question.name, label: question.nombre, name: question.name, nombre: question.nombre })
                } else {
                    auxQuestions.push({ value: question.name, label: question.name, name: question.name, nombre: question.nombre })
                }
            })
            setSecurityQuestionOptions(auxQuestions)
        })

    }, [locale])


    const IconPhoneOption = props => {
        return (<Option {...props} >
            <img
                src={props.data.flag}
                style={{ width: 20, marginRight: 5 }}
                alt={props.data.label}
            />
            <span >+{props.data.label}</span>

        </Option>)
    }

    const IconCountryOption = props => {
        return (<Option {...props} >
            <img
                src={props.data.flag}
                style={{ width: 20, marginRight: 5 }}
                alt={props.data.label}
            />
            <span >{props.data.label}</span>

        </Option>)
    };

    useEffect(() => {
        const index = indicativesOptions.findIndex((element) => element.value.toString() === indicativePhone)
        setPhoneIndex(index)
    }, [indicativePhone, indicativesOptions])

    useEffect(() => {
        const index = securityQuestionOptions.findIndex((element) => element.name === securityQuestion.name)
        setQuestionIndex(index)
    }, [securityQuestion, securityQuestionOptions])

    useEffect(() => {
        if (userType === 'influencer') {
            const index = identificationTypes.findIndex((element) => element.value === typeIdentification)
            setIdentificationIndex(index)
        }
    }, [typeIdentification, identificationTypes])

    useEffect(() => {
        if (userType === 'company') {
            const index = identificationTypesCompany.findIndex((element) => element.value === typeIdentification)
            setIdentificationIndex(index)
        }
    }, [typeIdentification, identificationTypesCompany])

    useEffect(() => {
        if (gender !== 'Femenino' && gender !== 'Female' && gender !== 'Masculino' && gender !== 'Male') {
            setShowCustomPronoun(true)
        } else {
            setShowCustomPronoun(false)
        }
    }, [gender])

    useEffect(() => {
        if (countriesOptions.length > 0 && country !== null) {
            const index = countriesOptions.findIndex((element) => element.name === country.name)
            setCountryIndex(index)
        }
    }, [country, countriesOptions])

    useEffect(() => {
        const auxCountries = countriesOptions;
        auxCountries.map((country) => {
            if (locale === 'es-CO') {
                auxCountries.push({ value: country.id, label: country.nombre, nombre: country.nombre, name: country.name })
            } else {
                auxCountries.push({ value: country.id, label: country.name, nombre: country.nombre, name: country.name })
            }
        })

    }, [locale])



    const selectStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px',
            boxShadow: 'none', height: '30px', minHeight: '34px', flexWrap: 'no-wrap'

        }),
        menu: (styles) => ({
            ...styles, display: 'flex'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        placeholder: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        singleValue: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E'
        })
    };
    const selectPhoneStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px',
            boxShadow: 'none', height: '30px', minHeight: '34px', flexWrap: 'no-wrap'

        }),
        menu: (styles) => ({
            ...styles, display: 'flex', width: '100px'
        }),
        option: (styles) => ({
            ...styles, display: 'flex', alignItems: 'center'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        placeholder: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        singleValue: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E'
        })
    };

    const selectCountryStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px',
            boxShadow: 'none', height: '30px', minHeight: '34px', flexWrap: 'no-wrap', minWidth: '180px'
        }),
        menu: (styles) => ({
            ...styles, display: 'flex', width: '180px'
        }),
        option: (styles) => ({
            ...styles, display: 'flex', alignItems: 'center'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        placeholder: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        singleValue: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E'
        })
    };

    const selectIndentificationStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px',
            boxShadow: 'none', height: '30px', minHeight: '34px', flexWrap: 'no-wrap', /* width: '100%', */ /* backgroundColor: 'red' */
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        placeholder: (styles) => ({
            ...styles, width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        singleValue: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E'
        })
    };


    const renderCustomInput = ({ ref }) => (
        <input
            readOnly
            ref={ref}
            placeholder={intl.formatMessage({ id: "signup_datepicker", defaultMessage: 'Elige tu fecha de nacimiento' })}
            value={selectedDay ? `${selectedDay.day}/${selectedDay.month}/${selectedDay.year}` : ''}
            style={{
                padding: '5px 10px',
                fontSize: '1rem',
                fontWeight: 500,
                fontFamily: 'Open Sans',
                border: '1px solid #BCBCBC',
                borderRadius: '10px',
                // width: '100%',
                outline: 'none',
                width: '250px',

            }}
            className="my-custom-input-class"
        />
    );



    const checkUniqueName = () => {
        if (userType === 'influencer') {

            if (auxUniqueName === '') {
                setAuxUniqueName(uniqueName);
                setIsUniqueNameEmpty(false);
            } else if (auxUniqueName !== uniqueName) {
                getInfluencerNameToVerified({ userName: auxUniqueName }).then((response) => {
                    if (response.length > 0) {
                        setIsUniqueNameAvailable(false);
                    } else {
                        setIsUniqueNameAvailable(true);
                        setUniqueName(`${auxUniqueName}`);
                        const auxBody = { ...body }
                        auxBody.username = `${auxUniqueName}`
                        setBody(auxBody)
                    }
                })
            } else {
                setIsUniqueNameAvailable(true);
            }

        } else if (userType === 'company') {

            if (auxUniqueName === '') {
                //setIsUniqueNameEmpty(true);
                setAuxUniqueName(uniqueName);
                setIsUniqueNameEmpty(false);
            } else if (auxUniqueName !== uniqueName) {
                getCompanyNameToVerified({ userName: auxUniqueName }).then((response) => {

                    if (response.length > 0) {
                        setIsUniqueNameAvailable(false);

                    } else {
                        setIsUniqueNameAvailable(true);
                        setUniqueName(`${auxUniqueName}`);
                        const auxBody = { ...body }
                        auxBody.username = `${auxUniqueName}`
                        setBody(auxBody)
                    }
                })
            } else {
                setIsUniqueNameAvailable(true);
            }
        }
    }

    const checkEmail = () => {
        if (auxEmail !== email) {
            getCheckEmailAvailability({ email: auxEmail.toLowerCase() }).then((response) => {
                if (response.length > 0) {
                    setIsEmailAvailable(false);
                } else {
                    if (userType === 'influencer') {
                        getInfluencerEmailToVerified({ email: auxEmail.toLowerCase() }).then((response) => {
                            if (response.length > 0) {
                                setIsEmailAvailable(false)
                            } else {
                                setIsEmailAvailable(true);
                                setShowSecurityCode(true);
                            }
                        })
                    } else if (userType === 'company') {
                        getCompanyEmailToVerified({ email: auxEmail }).then((response) => {

                            if (response.length > 0) {
                                setIsEmailAvailable(false)
                            } else {
                                setIsEmailAvailable(true);
                                setShowSecurityCode(true);
                            }
                        })
                    }
                }
            })
        } else {
            setIsEmailAvailable(true);
        }

        /* if (userType === 'influencer') {
            if (auxEmail !== email) {
                getInfluencerEmailToVerified({ email: auxEmail }).then((response) => {
                    console.log(response)
                    if (response.length > 0) {
                        setIsEmailAvailable(false)
                    } else {
                        setIsEmailAvailable(true);
                        setShowSecurityCode(true);
                    }
                })
            } else {
                setIsEmailAvailable(true);
            }


        } else if (userType === 'company') {

            if (auxEmail !== email) {
                getCompanyEmailToVerified({ email: auxEmail }).then((response) => {

                    if (response.length > 0) {
                        setIsEmailAvailable(false)
                    } else {
                        setIsEmailAvailable(true);
                        setShowSecurityCode(true);
                    }
                })
            } else {
                setIsEmailAvailable(true);
            }
        } */
    }

    useEffect(() => {
        if (showSecurityCode === false) {
            if (isEmailVerified) {
                setEmail(auxEmail);
                const auxBody = { ...body }
                auxBody.mail = auxEmail.toLowerCase();
                setBody(auxBody)
            } else {
                setAuxEmail(email);
            }
        }
    }, [isEmailVerified, showSecurityCode])


    const validateEmail = () => {
        const expRegEmail = new RegExp('[a-z0-9]+@[a-z]+[.][a-z]{2,3}');

        if (expRegEmail.test(secondEmail)) {
            setIsEmailValid(true);
            const auxBody = { ...body }
            auxBody.secondMail = secondEmail.toLowerCase();
            setBody(auxBody)
        } else {
            setIsEmailValid(false);
        }
    }

    const validatePassword = () => {
        const expRegPassword = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$");

        if (expRegPassword.test(password)) {
            setIsPasswordValid(true);
            const auxBody = { ...body }
            auxBody.password = password;
            setBody(auxBody)
        } else {
            setIsPasswordValid(false);
        }
    }

    const validatePhone = () => {

        if (phone.length > 8) {
            setIsPhoneValid(true)
            const auxBody = { ...body }
            auxBody.phoneNumber = phone;
            setBody(auxBody)
        } else {
            setIsPhoneValid(false)
        }

    }

    useEffect(() => {
        if (address !== null && address.length > 0) {
            const auxBody = { ...body }
            auxBody.address = `${address}`;
            setBody(auxBody)
        }
    }, [address])

    useEffect(() => {
        if (city !== null && city.length > 0) {
            const auxBody = { ...body }
            auxBody.city = `${city}`;
            setBody(auxBody)
        }
    }, [city])

    useEffect(() => {
        if (Object.keys(selectCountry).length > 0) {
            const auxBody = { ...body }
            auxBody.idCountry = selectCountry.value;
            setBody(auxBody);
        }
    }, [selectCountry])

    useEffect(() => {
        if (zipCode !== undefined && zipCode.length > 0) {
            const auxBody = { ...body }
            auxBody.attributes = { ...body.attributes, zipcode: zipCode };
            setBody(auxBody)
        }
    }, [zipCode])


    const save = () => {

        setIsLoading(true);
        setShowEdit(false);

        setEditAddress(false)
        setEditBirthday(false);
        setEditEmail(false);
        setEditGender(false);
        setEditIdentification(false);
        setEditInfluencerName(false);
        setEditPhone(false);
        setEditSecondaryEmail(false);
        setEditSecurityQuestion(false);
        setEditUserName(false);
        setEditPassword(false);


        if (!isPhoneValid || !isEmailValid || !isPasswordValid) {
            setIsLoading(false);
            setShowAlertChangeFail(true);
        } else {

            if (userType === 'influencer') {

                if (auxUniqueName === '') {
                    //setIsUniqueNameEmpty(true);
                    setIsLoading(false);
                    setAuxUniqueName(uniqueName);
                    setIsUniqueNameEmpty(false);
                } else if (auxUniqueName !== uniqueName) {
                    getInfluencerNameToVerified({ userName: auxUniqueName }).then((response) => {

                        if (response.length > 0) {
                            setIsUniqueNameAvailable(false);
                            setIsLoading(false);
                        } else {
                            setIsUniqueNameAvailable(true);
                            setUniqueName(`${auxUniqueName}`);
                            const auxBody = { ...body }
                            auxBody.username = `${auxUniqueName}`
                            setBody(auxBody)

                            postEditUserDataInfluencer({ body: { ...body, username: `${auxUniqueName}` }, token: userToken }).then((response) => {
                                setIsLoading(false);
                                if (response.status === 201) {
                                    setShowAlertChangeSuccessful(true);
                                }
                            })
                        }
                    })
                } else {
                    setIsUniqueNameAvailable(true);
                    postEditUserDataInfluencer({ body: { ...body, username: `${auxUniqueName}` }, token: userToken }).then((response) => {
                        setIsLoading(false);
                        if (response.status === 201) {
                            setShowAlertChangeSuccessful(true);
                        }
                    })
                }

            } else if (userType === 'company') {

                if (auxUniqueName === '') {
                    //setIsUniqueNameEmpty(true);
                    setIsLoading(false);
                    setAuxUniqueName(uniqueName);
                    setIsUniqueNameEmpty(false);
                } else if (auxUniqueName !== uniqueName) {
                    getCompanyNameToVerified({ userName: auxUniqueName }).then((response) => {

                        if (response.length > 0) {
                            setIsUniqueNameAvailable(false);
                            setIsLoading(false);
                        } else {
                            setIsUniqueNameAvailable(true);
                            setUniqueName(`${auxUniqueName}`);
                            const auxBody = { ...body }
                            auxBody.username = `${auxUniqueName}`
                            setBody(auxBody)
                            putEditUserDataCompany({ body: { ...body, username: `${auxUniqueName}` }, token: userToken }).then((response) => {
                                setIsLoading(false);
                                if (response.status === 201) {
                                    setShowAlertChangeSuccessful(true);
                                }
                            })
                        }
                    })
                } else {
                    setIsUniqueNameAvailable(true);
                    putEditUserDataCompany({ body: { ...body, username: `${auxUniqueName}` }, token: userToken }).then((response) => {
                        setIsLoading(false);
                        if (response.status === 201) {
                            setShowAlertChangeSuccessful(true);
                        }
                    })
                }
            }








            //console.log("🤐", body)
            /* if (userType === 'influencer') {
                postEditUserDataInfluencer({ body, token: userToken }).then((response) => {
                    setIsLoading(false);
                    if (response.status === 201) {
                        setShowAlertChangeSuccessful(true);
                    }
                })
            } else if (userType === 'company') {

                //EDITAR COMPANY
                putEditUserDataCompany({ body, token: userToken }).then((response) => {
                    setIsLoading(false);
                    if (response.status === 201) {
                        setShowAlertChangeSuccessful(true);
                    }
                })
            } */
        }
    }

    const deleteAccount = () => {
        setShowAlertConfirmDelete(false)
        setIsLoading(true);
        getDeleteAccount({ userType: userType, token: userToken }).then((response) => {
            if (response.status === 200) {
                setShowAlertDeleteAccount(true);
                setIsLoading(false);
            }
        })

        /* if (userType === 'influencer') {
            deleteInfluencerAccount({ token: userToken }).then((response) => {

                if (response.status === 200) {
                    localStorage.removeItem('fluincrToken');
                    localStorage.removeItem('fluincrUser');
                    sessionStorage.removeItem('fluincrToken');
                    sessionStorage.removeItem('fluincrUser');
                    setUserToken(null);
                    setUserType('');
                    navigate('/');
                }

            })
        } else {
            deleteCompanyAccount({ token: userToken }).then((response) => {

                if (response.status === 200) {
                    localStorage.removeItem('fluincrToken');
                    localStorage.removeItem('fluincrUser');
                    sessionStorage.removeItem('fluincrToken');
                    sessionStorage.removeItem('fluincrUser');
                    setUserToken(null);
                    setUserType('');
                    navigate('/');
                }

            })
        } */

    }

    const deletePayment = () => {
        setIsLoading(true);
        const bodyPaypal = {
            attributes: {
                paypal: false
            }
        }
        const bodyPaypalManualDelete = {
            attributes: {
                paypal: false,
                at_paypal: '',
                rt_paypal: '',
                email_paypal: ''
            },
            idsocialnetwork: {
                paypal: ''
            }
        }
        paypalDisconect({ typeUser: userType, token: userToken }).then((response) => {
            if (response.status === 200) {

                if (userType === 'influencer') {
                    postEditUserDataInfluencer({ body: bodyPaypal, token: userToken }).then((responseEdit) => {
                        setIsLoading(false);
                        if (responseEdit.status === 201) {
                            setPayment(false)
                            setShowDeletePayment(false);
                        } else {
                            window.alert('We could not complete your request at the moment, please try again later')
                        }
                    })
                } else if (userType === 'company') {
                    putEditUserDataCompany({ body: bodyPaypal, token: userToken }).then((responseEdit) => {
                        setIsLoading(false);
                        if (responseEdit.status === 201) {
                            setPayment(false);
                            setShowDeletePayment(false);
                        } else {
                            window.alert('We could not complete your request at the moment, please try again later')
                        }
                    })
                }
            } else if (response.status === 400) {
                if (userType === 'influencer') {
                    postEditUserDataInfluencer({ body: bodyPaypalManualDelete, token: userToken }).then((responseEdit) => {
                        setIsLoading(false);
                        if (responseEdit.status === 201) {
                            setPayment(false)
                            setShowDeletePayment(false);
                        } else {
                            window.alert('We could not complete your request at the moment, please try again later')
                        }
                    })
                } else if (userType === 'company') {
                    putEditUserDataCompany({ body: bodyPaypalManualDelete, token: userToken }).then((responseEdit) => {
                        setIsLoading(false);
                        if (responseEdit.status === 201) {
                            setPayment(false);
                            setShowDeletePayment(false);
                        } else {
                            window.alert('We could not complete your request at the moment, please try again later')
                        }
                    })
                }
            } else {
                setIsLoading(false);
                setShowDeletePayment(false);
            }

        })
    }

    return (
        <MyAccountContainer>
            <div className="goBack" onClick={() => navigate(-1)}>
                <img src={back} alt="go back" className="backIcon" />
                <p className="backText"><FormattedMessage id="go_back" defaultMessage="Ir atrás" /></p>
            </div>
            <div className="myAccountInformation">
                <h2 className="title"><FormattedMessage id="myAccount_title" defaultMessage="Mi cuenta" /></h2>
                <div className="profile">

                    <ProfileImage image={(imageProfile !== '' && imageProfile !== null) ? imageProfile : avatar} />

                    <div className="profileMainData">
                        <p className="name">
                            {/* {(userType === 'influencer') ? (toUpperCase({ fullName: `${name} ${lastName}` })) : (toUpperCase({ fullName: `${companyName}` }))} */}
                            {/* <img src={share} alt="edit" className="share" /> */}


                            {(userType === 'influencer') && ((editInfluencerName) ? (<><input type='text' value={name} onChange={(evet) => {
                                setName(evet.target.value)
                                const auxBody = { ...body }
                                auxBody.givenName = evet.target.value.toLowerCase().trim();
                                setBody(auxBody)
                            }} onBlur={() => {
                                setEditInfluencerName(false);
                            }} placeholder={intl.formatMessage({ id: "signup_input_1" })} /><input type='text' value={lastName} onChange={(evet) => {
                                setLastName(evet.target.value)
                                const auxBody = { ...body }
                                auxBody.familyName = evet.target.value.toLowerCase().trim();
                                setBody(auxBody)
                            }} onBlur={() => {
                                setEditInfluencerName(false);
                            }} placeholder={intl.formatMessage({ id: "signup_input_2" })} /></>) : (toUpperCase({ fullName: `${name} ${lastName}` })))}

                            {(userType === 'company') && ((editInfluencerName) ? (<input type='text' value={companyName} onChange={(evet) => {
                                setCompanyName(evet.target.value)
                                const auxBody = { ...body }
                                auxBody.nameCompany = evet.target.value.toLowerCase().trim();
                                setBody(auxBody)
                            }} onBlur={() => {
                                setEditInfluencerName(false);
                            }} placeholder={intl.formatMessage({ id: "signup_input_7" })} />) : (toUpperCase({ fullName: `${companyName}` })))}


                            {(showEdit) && (<img src={edit} alt="edit" className="edit" onClick={() => { setEditInfluencerName(!editInfluencerName) }} />)}
                        </p>
                        <p className="account"><FormattedMessage id="myAccount_subtitle_1" defaultMessage="Cuenta #" />{account}{' ('}
                            {(active) && (<span><FormattedMessage id="myAccount_state_1" defaultMessage="Activa" /></span>)}

                            {(statusAccount === 'ELIMINADO') && (<span><FormattedMessage id="myAccount_state_4" defaultMessage="Eliminado" /></span>)}

                            {(statusAccount === 'SUSPENDIDO') && (<span><FormattedMessage id="myAccount_state_5" defaultMessage="Suspendido" /></span>)}

                            {(verified) ? (<span>{' / '}<FormattedMessage id="myAccount_state_2" defaultMessage="Verificada" /></span>) : (<span>{' / '}<FormattedMessage id="myAccount_state_3" defaultMessage="No Verificada" /></span>)}
                            {') '}</p>
                    </div>
                </div>
                <div className="informationContainer">
                    <div className="information">
                        <p className="subtitle"><FormattedMessage id="myAccount_subtitle_2" defaultMessage="Nombre de usuario:" /></p>
                        <div>

                            <p>fluincr.com/{(editUserName) ? <input type='text' value={auxUniqueName} onChange={(evet) => {
                                setAuxUniqueName(evet.target.value);
                                //checkUniqueName();
                                console.log(evet.target.value)
                                if (evet.target.value !== '') {
                                    setIsUniqueNameEmpty(false);
                                } else {
                                    setIsUniqueNameEmpty(true);
                                }
                            }} onBlur={() => {
                                setEditUserName(false);
                                checkUniqueName()
                            }} /> : auxUniqueName}</p>

                            {(!isUniqueNameAvailable) && (<p className="error">
                                <FormattedMessage id="myAccount_error_1" defaultMessage="Este user name no está disponible" />
                            </p>)}
                            {(isUniqueNameEmpty) && (<p className="error">
                                <FormattedMessage id="myAccount_error_6" defaultMessage="El user name no puede ser vacío" />
                            </p>)}
                        </div>

                        <div className="share" ref={shareRef}>
                            <img src={share} alt="edit" className="shareIcon" onClick={() => { setShowSocialMedia(!showSocialMedia) }} />
                            {(showSocialMedia) && (<SocialMedia shareUrl={url} />)}
                        </div>

                        {/* <img src={share} alt="edit" className="share" /> */}
                    </div>
                    {(showEdit) && (<img src={edit} alt="edit" className="edit" onClick={() => { setEditUserName(!editUserName) }} />)}


                </div>

                <div className="informationContainer">
                    <div className="information">
                        <p className="subtitle"><FormattedMessage id="myAccount_subtitle_3" defaultMessage="Email:" /></p>
                        <div>
                            {(editEmail) ? <input type='email' value={auxEmail} onChange={(evet) => { setAuxEmail(evet.target.value) }} onBlur={() => {
                                setEditEmail(false)
                                checkEmail()
                            }} /> : <p>{auxEmail}</p>}
                            {(!isEmailAvailable) && (<p className="error">
                                <FormattedMessage id="myAccount_error_2" defaultMessage="Este email no está disponible" /></p>)}
                        </div>

                    </div>
                    {(showEdit) && (
                        <img src={edit} alt="edit" className="edit" onClick={() => { setEditEmail(!editEmail) }} />
                    )}

                </div>

                <div className="informationContainer">
                    <div className="information">
                        <p className="subtitle"><FormattedMessage id="myAccount_subtitle_4" defaultMessage="Email secundario:" /></p>
                        <div>
                            {(editSecondaryEmail) ? <input type='email' value={secondEmail} onChange={(evet) => { setSecondEmail(evet.target.value) }} onBlur={() => {
                                setEditSecondaryEmail(false)
                                validateEmail()
                            }} /> : <p>{secondEmail}</p>}
                            {(!isEmailValid) && (<p className="error"><FormattedMessage id="myAccount_error_3" defaultMessage="Este email no es válido" /></p>)}
                        </div>


                    </div>
                    {(showEdit) && (
                        <img src={edit} alt="edit" className="edit" onClick={() => { setEditSecondaryEmail(!editSecondaryEmail) }} />
                    )}

                </div>

                <div className="informationContainer">
                    <div className="information">
                        <p className="subtitle"><FormattedMessage id="myAccount_subtitle_5" defaultMessage="Contraseña:" /></p>
                        <div className="password">
                            <div>
                                {(editPassword) ? <input type='text' value={password} onChange={(evet) => { setPassword(evet.target.value) }} onBlur={() => {
                                    setEditPassword(false)
                                    validatePassword()
                                }} /> : <p>xxxxxxxxxx</p>}

                                {(!isPasswordValid) && (<p className="error"><FormattedMessage id="myAccount_error_4" defaultMessage="Esta contraseña no es válida" /></p>)}
                            </div>

                            <div className="verification">
                                <label className="switch">
                                    <input type="checkbox" checked={twoStepVerification} onClick={(event) => {
                                        setTwoStepVerification(event.target.checked);
                                        const auxBody = { ...body }
                                        auxBody.attributes = { ...body.attributes, twoStepVerification: event.target.checked };
                                        setBody(auxBody)
                                    }} />
                                    <div className="slider"></div>
                                </label>

                                <FormattedMessage id="myAccount_text_1" defaultMessage="Vefificación de dos pasos" />

                            </div>

                        </div>

                    </div>
                    {(showEdit) && (
                        <img src={edit} alt="edit" className="edit" /* onClick={() => { setEditPassword(!editPassword) }} */
                            onClick={() => { setShowEditPassword(true) }} />
                    )}

                </div>

                <div className="informationContainer">
                    <div className="information">
                        <p className="subtitle"><FormattedMessage id="myAccount_subtitle_6" defaultMessage="Pregunta de seguridad:" /></p>

                        {(editSecurityQuestion) ?
                            <div className="securityQuestionContainer" >
                                <Select options={securityQuestionOptions}
                                    styles={selectStyles}
                                    defaultValue={securityQuestionOptions[questionIndex]}
                                    placeholder={intl.formatMessage({ id: "myAccount_text_7" })}
                                    onChange={(event) => {
                                        setSecurityQuestion(event)
                                        const auxBody = { ...body }
                                        auxBody.attributes = {
                                            ...body.attributes,
                                            securityQuestion: event.name,
                                            preguntaSeguridad: event.nombre
                                        };
                                        setBody(auxBody)
                                    }}
                                />
                            </div> : <p>{(locale === 'es-CO') ? securityQuestion.nombre : securityQuestion.name}</p>}

                    </div>
                    {(showEdit) && (
                        <img src={edit} alt="edit" className="edit" onClick={() => { setEditSecurityQuestion(!editSecurityQuestion) }} />
                    )}

                </div>

                {(editSecurityQuestion) && (<div className="informationContainer" >
                    <div className="information">
                        <p className="subtitle"><FormattedMessage id="myAccount_subtitle_13" defaultMessage="Respuesta" /></p>
                        <input type='text' value={securityQuestionAnswer} onChange={(evet) => {
                            setSecurityQuestionAnswer(evet.target.value)
                            const auxBody = { ...body }
                            auxBody.attributes = {
                                ...body.attributes,
                                securityAnswer: evet.target.value
                            };
                            setBody(auxBody)
                        }} onBlur={() => { setEditSecurityQuestion(false) }} />
                    </div>

                </div>)}

                <div className="informationContainer">
                    <div className="information">
                        <p className="subtitle"><FormattedMessage id="myAccount_subtitle_7" defaultMessage="Teléfono:" /></p>
                        <div>
                            {(editPhone) ? <div className="phoneContainer" >
                                <Select options={indicativesOptions}
                                    styles={selectPhoneStyles}
                                    placeholder={intl.formatMessage({ id: "myAccount_text_5" })}
                                    defaultValue={indicativesOptions[phoneIndex]}
                                    onChange={(event, index) => {
                                        setSelectIndicative(event.label)
                                        setIndicativePhone(event.label.toString())
                                        const auxBody = { ...body }
                                        auxBody.indicative = event.label.toString();
                                        setBody(auxBody)
                                    }}
                                    components={{ Option: IconPhoneOption }}
                                />
                                <input type='text' value={phone} onChange={(evet) => {
                                    setPhone(evet.target.value)
                                }} onBlur={() => {
                                    setEditPhone(false)
                                    validatePhone()
                                }} />
                            </div>

                                : <p>{indicativePhone && `+ ${indicativePhone}`} {phone}</p>
                            }
                            {(!isPhoneValid) && (<p className="error"><FormattedMessage id="myAccount_error_5" defaultMessage="Este télefono no es válido" /></p>)}
                        </div>

                    </div>
                    {(showEdit) && (
                        <img src={edit} alt="edit" className="edit" onClick={() => {
                            setEditPhone(!editPhone)
                        }} />
                    )}

                </div>

                <div className="informationContainer">
                    <div className="information">
                        <p className="subtitle"><FormattedMessage id="signup_input_6" defaultMessage="ID/Identificación" /></p>

                        {(editIdentification) ? <div className="identificationContainer" >
                            <div className='identificationType'>
                                {(userType === 'influencer') ? (<Select options={identificationTypes}
                                    styles={selectIndentificationStyles}
                                    defaultValue={identificationTypes[identificationIndex]}
                                    placeholder={intl.formatMessage({ id: "myAccount_text_6" })}
                                    onChange={(event) => {
                                        setTypeIdentification(event.value);
                                        const auxBody = { ...body }
                                        auxBody.attributes = { ...body.attributes, typeId: event.value };
                                        setBody(auxBody)
                                    }}
                                />) : (<Select options={identificationTypesCompany}
                                    styles={selectIndentificationStyles}
                                    defaultValue={identificationTypesCompany[identificationIndex]}
                                    placeholder={intl.formatMessage({ id: "myAccount_text_6" })}
                                    onChange={(event) => {
                                        setTypeIdentification(event.value);
                                        const auxBody = { ...body }
                                        auxBody.attributes = { ...body.attributes, typeId: event.value };
                                        setBody(auxBody)
                                    }}
                                />)}

                            </div>

                            <input type='text' value={identification} onChange={(event) => {
                                setIdentification(event.target.value)
                                setIdentification(event.target.value);
                                const auxBody = { ...body }
                                auxBody.attributes = { ...body.attributes, numberId: event.target.value };
                                setBody(auxBody)
                            }} onBlur={() => {
                                setEditIdentification(false);

                            }} className='identification' />

                        </div> : <p>{identification}</p>}

                    </div>
                    {(showEdit) && (
                        <img src={edit} alt="edit" className="edit" onClick={() => { setEditIdentification(!editIdentification) }} />
                    )}

                </div>

                {(userType === 'influencer') && (<>

                    <div className="informationContainer">
                        <div className="information">
                            <p className="subtitle"><FormattedMessage id="myAccount_subtitle_8" defaultMessage="Género:" /></p>
                            {(editGender) ?
                                <div className="gendersContainer" >
                                    <div className="genders">
                                        <div className="gender">
                                            <label htmlFor="female" >
                                                <FormattedMessage id="signup_text_3_subtext_1" defaultMessage="Female" />
                                            </label>
                                            <input type="radio" id="female" name="gender" value={intl.formatMessage({ id: "signup_text_3_subtext_1" })} onChange={(event) => {
                                                //setShowCustomPronoun(false)
                                                setGender(event.target.value);
                                                const auxBody = { ...body }
                                                auxBody.gender = event.target.value;
                                                setBody(auxBody)
                                            }} checked={gender === 'Femenino' || gender === 'Female'} />
                                        </div>
                                        <div className="gender">
                                            <label htmlFor="male" >
                                                <FormattedMessage id="signup_text_3_subtext_2" defaultMessage="Male" />
                                            </label>
                                            <input type="radio" id="male" name="gender" value={intl.formatMessage({ id: "signup_text_3_subtext_2" })} onChange={(event) => {
                                                //setShowCustomPronoun(false)
                                                setGender(event.target.value)
                                                const auxBody = { ...body }
                                                auxBody.gender = event.target.value;
                                                setBody(auxBody)
                                            }} checked={gender === 'Masculino' || gender === 'Masculino'} />
                                        </div>
                                        <div className="gender">
                                            <label htmlFor="other" >
                                                <FormattedMessage id="signup_text_3_subtext_3" defaultMessage="Other" />
                                            </label>
                                            <input type="radio" id="other" name="gender" value={intl.formatMessage({ id: "signup_text_3_subtext_3" })} onChange={() => {
                                                setGender('');
                                                //setShowCustomPronoun(true)
                                            }} checked={gender !== 'Femenino' && gender !== 'Female' && gender !== 'Masculino' && gender !== 'Male'} />
                                        </div>
                                    </div>
                                    {(showCustomPronoun) && (<input type='text' value={gender} placeholder={intl.formatMessage({ id: "signup_select" })} onChange={(event) => {
                                        setGender(event.target.value);
                                        const auxBody = { ...body }
                                        auxBody.gender = event.target.value;
                                        setBody(auxBody)
                                    }} />)}
                                </div> :
                                <p className="genderName">{(locale !== 'es-CO') ? gender : (gender.toLowerCase() === 'female') ? 'femenino' : (gender.toLowerCase() === 'male') ? 'masculino' : gender}</p>
                            }

                        </div>
                        {(showEdit) && (
                            <img src={edit} alt="edit" className="edit" onClick={() => { setEditGender(!editGender) }} />
                        )}

                    </div>

                    <div className="informationContainer" ref={birthdayRef}>
                        <div className="information" >
                            <p className="subtitle"><FormattedMessage id="myAccount_subtitle_9" defaultMessage="Fecha de nacimiento:" /></p>

                            {(editBirthday) ? (
                                <DatePicker

                                    value={selectedDay}
                                    onChange={
                                        setSelectedDay
                                    }
                                    //calendarClassName="custom-calendar"
                                    renderInput={renderCustomInput}
                                    colorPrimary="#E8339E"
                                    maximumDate={utils().getToday()}
                                /* renderFooter={() => (
                                    <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '20px' }}>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setSelectedDay(null)
                                            }}
                                            style={{
                                                border: '#0fbcf9',
                                                color: '#fff',
                                                borderRadius: '0.5rem',
                                                padding: '10px 20px',
                                                backgroundColor: '#E8339E',
                                                margin: '0'
                                            }}
                                        >
                                            <FormattedMessage id="modal_prices_text_5" defaultMessage="Restablecer valor" />
                                        </button>
                                    </div>
                                )} */
                                />


                            ) : (<p>{birthday}</p>)}

                        </div>
                        {(showEdit) && (
                            <img src={edit} alt="edit" className="edit" onClick={() => { setEditBirthday(!editBirthday) }} />
                        )}

                    </div>

                </>)}


                <div className="informationContainer">
                    <div className="information">
                        <p className="subtitle">{(userType === 'influencer') ? (
                            <FormattedMessage id="myAccount_subtitle_10_a" defaultMessage="Dirección de envío:" />
                        ) : (
                            <FormattedMessage id="myAccount_subtitle_10_b" defaultMessage="Dirección:" />
                        )}
                        </p>
                        {(editAddress) ?
                            <div className="address" >
                                <div className="addressData">
                                    <input type="text" placeholder={intl.formatMessage({ id: "address_details" })} value={address} className="addressInput" onChange={(evet) => {
                                        //setAddressDetails(evet.target.value) 
                                        setAddress(evet.target.value)
                                    }} />
                                </div>
                                <div className="addressCountry">
                                    <Select options={countriesOptions}
                                        styles={selectCountryStyles}
                                        placeholder={intl.formatMessage({ id: "address_country" })}
                                        defaultValue={countriesOptions[countryIndex]}
                                        onChange={(event) => {
                                            setSelectCountry(event)
                                            setCountry(event)
                                        }}
                                        components={{ Option: IconCountryOption }}
                                    />

                                    <input type='text' placeholder={intl.formatMessage({ id: "address_city" })} value={city} onChange={(evet) => { setCity(evet.target.value) }} onBlur={() => {
                                        setEditAddress(false)
                                        //setAddress(`${addressDetails}, ${selectCountry.label}-${city}`)
                                    }} className="city" />


                                </div>
                                <input type='text' placeholder={intl.formatMessage({ id: "address_code" })} value={zipCode} onChange={(evet) => { setZipCode(evet.target.value) }} onBlur={() => {
                                    setEditAddress(false)
                                    //setAddress(`${addressDetails}, ${selectCountry.label}-${city}`)
                                }} className="zipCode" />
                            </div>
                            : <div className="addressInfo">
                                <p>{(`${(address !== null) ? `${address},` : ''} ${(locale === 'es-CO') ? (country?.nombre) : (country?.name)} ${(city !== null && city !== '') ? `- ${city}` : ''}`)} </p>
                                <p>{(zipCode !== undefined && zipCode !== null && zipCode !== '') && ` ${zipCode}`}</p>
                            </div>}

                    </div>
                    {(showEdit) && (
                        <img src={edit} alt="edit" className="edit" onClick={() => {
                            setEditAddress(!editAddress)
                            //setAddress(`${addressDetails}, ${selectCountry.label}-${city}`)
                        }} />
                    )}

                </div>

                <div className="informationContainer">
                    <div className="information">
                        <p className="subtitle"><FormattedMessage id="myAccount_subtitle_11" defaultMessage="Método de pago:" /></p>

                        {/* <label htmlFor="pay"> <input type="checkbox" id="pay" name="pay" value="pay" checked={payment} onChange={(event) => {
                            setPayment(event.target.checked)
                            const auxBody = { ...body }
                            auxBody.attributes = { ...body.attributes, paypal: event.target.checked };
                            setBody(auxBody)

                        }}
                        /> {paymentMethod}</label> */}
                        <span className="paymentMethod">{paymentMethod}</span>
                    </div>
                    {(showEdit) && (
                        <img src={edit} alt="edit" className="edit" onClick={() => {
                            if (payment === true) {
                                setShowDeletePayment(true);
                            } else {
                                sessionStorage.setItem('paypalLoginOrigin', 'account')
                                window.location = `${paypalURL}/${userType}?authorization=${userToken}`;
                                /* window.location = `${paypalURL}/${userType}`;
                                const myHeader = userToken;
                                const myHeaderKey = 'Authorization';
                                document.cookie = myHeaderKey + '= Bearer ' + myHeader; */
                            }
                        }} />
                    )}
                </div>

                <div className="informationContainer">
                    <div className="information">
                        <p className="subtitle"><FormattedMessage id="myAccount_subtitle_12" defaultMessage="Notificaciones:" /></p>
                        <div className="notifications">
                            {/* <label htmlFor="colaborations"> <input type="checkbox" id="colaborations" name="colaborations" value="colaborations" checked={colaborations} onChange={(event) => {
                                setColaborations(event.target.checked)
                                const auxBody = { ...body }
                                auxBody.notification = { ...body.notification, colaborations: event.target.checked };
                                setBody(auxBody)
                            }} /> <FormattedMessage id="myAccount_text_3" defaultMessage="Enviarme emails sobre colaboraciones/mi cuenta" /></label> */}

                            <label htmlFor="promotions"> <input type="checkbox" id="promotions" name="promotions" value="promotions" checked={promotions} onChange={(event) => {
                                setPromotions(event.target.checked)
                                const auxBody = { ...body }
                                auxBody.notification = { ...body.notification, promotions: event.target.checked };
                                setBody(auxBody)
                            }} /> <FormattedMessage id="myAccount_text_4" defaultMessage="Enviarme emails sobre promociones" /></label>
                        </div>
                    </div>
                </div>

            </div>

            <div className="buttons">
                <button className="deactivate" onClick={() => setShowAlertConfirmDelete(true)}>
                    {/*  <FormattedMessage id="myAccount_button_1_a" defaultMessage="Desactivar" /> / */}
                    <span ><FormattedMessage id="myAccount_button_1_b" defaultMessage="Borrar mi cuenta" /></span>
                </button>
                {(!showEdit) && (<button className="edit" onClick={() => { setShowEdit(true) }}>
                    <FormattedMessage id="myAccount_button_2" defaultMessage="Editar mi cuenta" />
                </button>)}

                <button className="save" onClick={save}>
                    <FormattedMessage id="myAccount_button_3" defaultMessage="Guardar" />
                </button>
            </div>

            {(isLoading) && (<Spinner />)}

            {(showAlertChangeSuccessful) && (<Alert
                title={<FormattedMessage id="alert_forward_title" defaultMessage="¡Exitoso!" />}
                text={<FormattedMessage id="alert_change_successful_text" defaultMessage="Los cambios se han realizado con éxito." />}
                setShowAlert={setShowAlertChangeSuccessful}
            />)}

            {(showAlertChangeFail) && (<Alert
                title={<FormattedMessage id="alert_forward_title_2" defaultMessage="¡Error!" />}
                text={<FormattedMessage id="alert_change_successful_text_2" defaultMessage="No se han guardado los cambios." />}
                setShowAlert={setShowAlertChangeFail}
            />)}

            {(showAlertDeleteAccount) && (<Alert
                title={<FormattedMessage id="alert_delete_account_email_title" defaultMessage="Revisa tu correo" />}
                text={<FormattedMessage id="alert_delete_account_email_text" defaultMessage="Se ha enviado un mensaje a tu correo para completar el proceso." />}
                setShowAlert={setShowAlertDeleteAccount}
            />)}

            {(showSecurityCode) && (<ModalSecurityCode setShowSecurityCode={setShowSecurityCode} body={{ mail: auxEmail.toLowerCase() }} setIsEmailVerified={setIsEmailVerified} page='MyAccount' /* setShowAlertUserExists={setShowAlertUserExists} */ />)}

            {/* {(showAlertUserExists) && (<Alert
                title={<FormattedMessage id="alert_user_exists_title" defaultMessage="Advertencia" />}
                text={<FormattedMessage id="##### alert_user_exists_text" defaultMessage="Este correo ya se encuentra registrado, por favor ingrese un correo diferente." />}
                setShowAlert={setShowAlertUserExists}
            />)} */}

            {(showEditPassword) && (<ModalChangePassword setShowEditPassword={setShowEditPassword} />)}

            {(showAlertConfirmDelete) && (<Alert
                title={<FormattedMessage id="alert_delete_account_title" defaultMessage="¡Eliminar!" />}
                text={<FormattedMessage id="alert_delete_account_text" defaultMessage="¿Estas seguro de que quieres eliminar tu cuenta?" />}
                confirmText={<FormattedMessage id="alert_delete_account_confirm_button" defaultMessage="Eliminar" />}
                cancelText={<FormattedMessage id="alert_delete_account_cancel_button" defaultMessage="Cancelar" />}
                onConfirm={deleteAccount}
                onCancel={() => setShowAlertConfirmDelete(false)}
                setShowAlert={setShowAlertConfirmDelete}
            />)}

            {(showDeletePayment) && (<Alert
                title={<FormattedMessage id="alert_delete_account_title" defaultMessage="¡Eliminar!" />}
                text={<FormattedMessage id="alert_delete_paypal" defaultMessage="¿Deseas eliminar la cuenta de paypal que tienes actualmente asociada a Fluincr?" />}
                confirmText={<FormattedMessage id="alert_delete_account_confirm_button" defaultMessage="Eliminar" />}
                cancelText={<FormattedMessage id="alert_delete_account_cancel_button" defaultMessage="Cancelar" />}
                onConfirm={deletePayment}
                onCancel={() => setShowDeletePayment(false)}
                setShowAlert={setShowDeletePayment}
            />)}

        </MyAccountContainer>
    )
}